import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable, catchError, throwError, tap } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable()
export class ErrorLoggingInterceptor implements HttpInterceptor {

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const startedAt = Date.now();
    return next.handle(req).pipe(
      tap((event) => {
        if (environment.logSuccessEvents && event instanceof HttpResponse) {
          const elapsed = Date.now() - startedAt;
          // this.logger.success('HTTP', 'Request succeeded', {
          //   method: req.method,
          //   url: req.urlWithParams,
          //   durationMs: elapsed,
          //   status: event.status,
          //   statusText: event.statusText,
          //   body: this.safeError(event.body)
          // });
        }
      }),
      catchError((error: HttpErrorResponse) => {
        const elapsed = Date.now() - startedAt;
        // this.logger.error(
        //   'HTTP',
        //   'Request failed',
        //   {
        //     method: req.method,
        //     url: req.urlWithParams,
        //     durationMs: elapsed,
        //     status: error.status,
        //     statusText: error.statusText,
        //     message: error.message,
        //     error: this.safeError(error.error)
        //   }
        // );
        return throwError(() => error);
      })
    );
  }

  private safeError(err: any) {
    try {
      if (typeof err === 'string') return err;
      if (err && typeof err === 'object') return { ...err };
      return err;
    } catch {
      return '[unserializable error]';
    }
  }
}
